import { useMutation } from '@tanstack/react-query';
import { request } from './client.ts';

/** POST /me/slack-link-code response (docs/05 §Slack): an 8-char one-time code, KV-scoped
 *  to the caller's org, valid for 10 minutes. Redeemed in Slack, never in the CMS. */
export interface SlackLinkCode {
  code: string;
  expires_at: number;
}

/** Mints a fresh link code. Always available — even when the org hasn't installed the
 *  Slack app yet, since only the `/slack/*` webhooks (not this endpoint) gate on that. */
export function useCreateSlackLinkCode() {
  return useMutation({
    mutationFn: () => request<SlackLinkCode>('/me/slack-link-code', { method: 'POST' }),
  });
}
